import { render, staticRenderFns } from "./AschoolFeature.vue?vue&type=template&id=131fbf0d&scoped=true"
import script from "./AschoolFeature.vue?vue&type=script&lang=js"
export * from "./AschoolFeature.vue?vue&type=script&lang=js"
import style0 from "./AschoolFeature.vue?vue&type=style&index=0&id=131fbf0d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131fbf0d",
  null
  
)

export default component.exports